"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 373.06 318.88",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M479.66,445.69H461.27V415.57a6.88,6.88,0,0,0-6.87-6.88h-17V348.37l5.65-9.09L240.62,204.86l7.56-44.73-24.84-19.57L219.68,142c-1.55.59-38.28,15.09-69.91,56.18-32.45,42.15-26.26,69.78-26,70.94l.73,3,21.57,11.2V432.44a6.88,6.88,0,1,0,13.75,0V283.11l47.77-40.33L256.7,273a34.72,34.72,0,0,0-1.84,24.18L216,445.69h-95.7a6.88,6.88,0,0,0,0,13.75H479.66a6.88,6.88,0,0,0,0-13.75ZM424.3,343.35l-7.49,12-94-57.86-.09-.34a34.53,34.53,0,0,0-.91-21.91Zm-161.82,48,15.72,13.78-35.41,31Zm5.8-13.2,20.5-46.65L309.2,378l-20.56,18Zm46.72,13L335,436.62l-35.88-31.44Zm-15.71-69.94a35.34,35.34,0,0,0,13.45-7.85l24.8,94.9ZM136.91,263.07c-.25-7.22,1.47-27.58,23.76-56.53,23.73-30.83,51-45.67,60.49-50.19l1.48,1.16-76.55,87.28v23Zm22.93,2V250l73.34-83.63-7.26,43Zm58.82-31.67,17.67-14.92,51,33.87a35.08,35.08,0,0,0-22.56,9.43Zm58.55,36a21.48,21.48,0,0,1,33.07,17.38c0,.25,0,.5,0,.75a19.64,19.64,0,0,1-.12,2.18,21.64,21.64,0,0,1-16.63,18.8l-.46.11a21.48,21.48,0,0,1-8.65,0l-.46-.11a21.59,21.59,0,0,1-16.75-21c0-.25,0-.5,0-.75a21.29,21.29,0,0,1,1.27-6.56A21.57,21.57,0,0,1,277.21,269.47Zm-12.38,44a35.27,35.27,0,0,0,13.45,7.85L240,408.33Zm-12,132.26,35.81-31.37,35.81,31.37Zm108.69,0L327.83,316.77l93.43,57.51,2.36-3.8v38.21h-17a6.88,6.88,0,0,0-6.87,6.88v30.12Zm51.94,0V422.44h34.06v23.25Z",
      transform: "translate(-113.47 -140.56)"
    })
  });
};

exports.default = Icon;